import {cashBoxViewPage} from "../../../hoc/cashBoxViewPage";

const Operation = cashBoxViewPage("Operation")

export default Operation
